import React, { Component } from 'react';
import { captureScreenshot } from '../../utils/screenshot';

const withScreenshot = () => WrappedComponent => {
  class WithScreenshot extends Component {
    constructor(props) {
      super(props);
      this.state = {
        screenshot: null
      };

      this.onCaptureScreenshot = this.onCaptureScreenshot.bind(this);
    }

    onCaptureScreenshot(callback) {
      captureScreenshot().then(screenshot =>
        this.setState(() => {
          return { screenshot };
        }, callback)
      );
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          onCaptureScreenshot={this.onCaptureScreenshot}
          screenshot={this.state.screenshot}
        />
      );
    }
  }

  WithScreenshot.displayName = `withScreenshot(${WrappedComponent.displayName ||
    WrappedComponent.name})`;
  return WithScreenshot;
};

export { withScreenshot };
